/*
 * @Author: 刘小博
 * @Date: 2023-02-17 15:55:01
 * @LastEditTime: 2023-06-02 19:22:50
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\cost-control\system-settings\modules\systemSettingRouter.js
 * 文件备注
 */
const systemSettingRouter = [
  // 费控系统 系统设置
  {
    path: '/costControlSystem/setting',
    name: 'costControlSystemSetting',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/setting/index.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '系统配置',
    },
  },
  // 费控系统 系统设置 数据字典
  {
    path: '/costControlSystem/setting/dictionaries',
    name: 'costControlSystemSettingDictionaries',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/setting/dictionaries/index.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '数据字典',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'costControlSystemSetting',
        },
      ],
    },
  },
  // 费控系统 系统设置 政策科目维护
  {
    path: '/costControlSystem/setting/policyAccountMaintenance',
    name: 'policyAccountMaintenance',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/setting/policy-account-maintenance/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '政策科目维护',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'costControlSystemSetting',
        },
      ],
    },
  },
  // 费控系统 系统设置 结算政策维护配置
  {
    path: '/costControlSystem/setting/settlementPolicyMaintenanceConfiguration',
    name: 'SettlementPolicyMaintenanceConfiguration',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/setting/settlement-policy-maintenance-configuration/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '结算政策维护配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'costControlSystemSetting',
        },
      ],
    },
  },
  // 费控系统 系统设置 结算政策维护配置 新增政策
  {
    path: '/costControlSystem/setting/settlementPolicyMaintenanceConfigurationAdd/:policy_setting_id',
    name: 'SettlementPolicyMaintenanceConfigurationAdd',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/setting/settlement-policy-maintenance-configuration/Add.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '新增政策',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'costControlSystemSetting',
        },
        {
          title: '结算政策维护配置',
          name: 'SettlementPolicyMaintenanceConfiguration',
        },
      ],
    },
  },
  // 费控系统 系统设置 费用结算审批配置
  {
    path: '/costControlSystem/setting/approval-configuration',
    name: 'costControlSystemSettingApprovalConfiguration',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/setting/approvalConfiguration/index.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '费用结算审批配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'costControlSystemSetting',
        },
      ],
    },
  },
  // 费控系统 系统设置 结算审批设置
  {
    path: '/costControlSystem/setting/approval-configuration/approval/:category/:title',
    name: 'costControlSystemSettingApprovalConfigurationApproval',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/setting/approvalConfiguration/Approval.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '结算审批设置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'costControlSystemSetting',
        },
        {
          title: '费用结算审批配置',
          name: 'costControlSystemSettingApprovalConfiguration',
        },
      ],
    },
  },
  // 费控系统 系统设置 操作日志
  {
    path: '/costControlSystem/setting/operationLog',
    name: 'costOperationLog',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/setting/operation-log/Page.vue'
      ),
    meta: {
      title: '操作日志',
      breadcrumb: [],
    },
  },
]
export default systemSettingRouter
